import { CartCalc } from "Components/Cart/CartCalc";
import { showPriceWithCurrentCurrency } from "Core/Currencies";
import * as $ from "jquery";

interface ValueTypes {
	currentThresholdMin?: number | string;
	currentThresholdMax?: number | string;
	remainingAmount?: number | string;
	currentCartAmount: number | string,
	barWidth?: number | string;
	currentThresholdPercent?: number | string;
	nextThresholdPercent?: number | string;
	lastThresholdPercent?: number | string;
}

const getRemainingAmountForNextThresholdTemplate = ({
	lastThresholdPercent,
	nextThresholdPercent,
	remainingAmount,
}: Pick<ValueTypes, 'lastThresholdPercent' | 'nextThresholdPercent' | 'remainingAmount'>) => `
Zyskaj nawet <b>${lastThresholdPercent}%</b> rabatu! <br>
Do osiągnięcia rabatu <b>${nextThresholdPercent}%</b> brakuje: <b>${showPriceWithCurrentCurrency(Number(remainingAmount), 2, 'comma')}</b>`;

export class Promotions {
	private static Selector = {
		BAR: ".js_promotions_bar",
		MIN_VALUE: ".js_promotions_minValue",
		MAX_VALUE: ".js_promotions_maxValue",
		REMAINING_AMOUNT_FOR_NEXT_THRESHOLD:
			".js_promotions_remainingAmountForNextThreshold",
		MESSAGE: ".js_promotions_message",
	};

	private static Values: ValueTypes = {
		currentThresholdMin: undefined as number | string,
		currentThresholdMax: undefined as number | string,
		remainingAmount: undefined as number | string,
		currentCartAmount: undefined as number | string,
		barWidth: undefined as number | string,
		currentThresholdPercent: undefined as number | string,
		nextThresholdPercent: undefined as number | string,
		lastThresholdPercent: undefined as number | string,
	};

	private static updateCurrentThresholdMinValue(newValue: number | string) {
		this.Values.currentThresholdMin = newValue;
		$(this.Selector.MIN_VALUE).text(
			showPriceWithCurrentCurrency(Number(newValue), 2, 'comma') || "-"
		);
	}

	private static updateCurrentThresholdMaxValue(newValue: number | string) {
		this.Values.currentThresholdMax = newValue;

		if (newValue !== null) {
			$(this.Selector.MAX_VALUE).text(
				showPriceWithCurrentCurrency(Number(newValue), 2, 'comma') || "-"
			);
		}
	}

	private static updateBarWidth(newValue: number | string) {
		this.Values.barWidth = newValue;
		$(this.Selector.BAR).width(`${newValue}%`);
	}

	private static updateRemainingAmount(newValue: number | string) {
		this.Values.remainingAmount = newValue;
		$(this.Selector.REMAINING_AMOUNT_FOR_NEXT_THRESHOLD).text(
			showPriceWithCurrentCurrency(Number(newValue), 2, 'comma') || "-"
		);
	}

	private static updateCurrentThresholdPercent(newValue: number | string) {
		this.Values.currentThresholdPercent = newValue;
	}

	private static updateNextThresholdPercent(newValue: number | string) {
		this.Values.nextThresholdPercent = newValue;
	}

	private static updateCurrentCartAmount(newValue: number | string) {
		this.Values.currentCartAmount = newValue;
	}

	private static getMessageAsHTML() {
		if (this.Values.currentThresholdMax === null || this.Values.currentThresholdMax === undefined) {
			return `Otrzymujesz dodatkowe <b>${this.Values.currentThresholdPercent}%</b> rabatu`;
		}

		return getRemainingAmountForNextThresholdTemplate({
			lastThresholdPercent: this.Values.lastThresholdPercent,
			remainingAmount: this.Values.remainingAmount,
			nextThresholdPercent: this.Values.nextThresholdPercent
		});
	}

	private static updateMessage(newMessage: string) {
		if (this.Values.currentThresholdMax === null || this.Values.currentThresholdMax === undefined) {
			$(this.Selector.MAX_VALUE).hide();
		} else {
			$(this.Selector.MAX_VALUE).show();
		}
		$(this.Selector.MESSAGE).html(newMessage);
	}

	private static calcBarWidth() {
		if (this.Values.currentThresholdMax === null || this.Values.currentThresholdMax === undefined) {
			return 100;
		}

		return (Number(this.Values.currentCartAmount) - Number(this.Values.currentThresholdMin)) / (Number(this.Values.currentThresholdMax) - Number(this.Values.currentThresholdMin)) * 100;
	}

	private static updateLastThresholdPercent(newValue: number | string) {
		this.Values.lastThresholdPercent = newValue;
	}

	static updateValues({
		barWidth,
		currentThresholdPercent: currentPromotionPercent,
		currentThresholdMin,
		currentThresholdMax,
		nextThresholdPercent: nextPromotionPercent,
		remainingAmount,
		currentCartAmount,
		lastThresholdPercent
	}: typeof this.Values) {
		this.updateLastThresholdPercent(lastThresholdPercent);
		this.updateCurrentThresholdMinValue(currentThresholdMin);
		this.updateCurrentThresholdMaxValue(currentThresholdMax);
		this.updateBarWidth(barWidth);
		this.updateRemainingAmount(remainingAmount);
		this.updateCurrentThresholdPercent(currentPromotionPercent);
		this.updateNextThresholdPercent(nextPromotionPercent);
		this.updateCurrentCartAmount(currentCartAmount);
		this.updateBarWidth(this.calcBarWidth());

		this.updateMessage(this.getMessageAsHTML());
	}
}
import { CartCalc } from "Components/Cart/CartCalc";
import { showPriceWithCurrentCurrency } from "Core/Currencies";
import * as $ from "jquery";

interface ValueTypes {
	currentThresholdMin?: number | string;
	currentThresholdMax?: number | string;
	remainingAmount?: number | string;
	currentCartAmount: number | string,
	barWidth?: number | string;
	currentThresholdPercent?: number | string;
	nextThresholdPercent?: number | string;
	lastThresholdPercent?: number | string;
}

const getRemainingAmountForNextThresholdTemplate = ({
	lastThresholdPercent,
	nextThresholdPercent,
	remainingAmount,
}: Pick<ValueTypes, 'lastThresholdPercent' | 'nextThresholdPercent' | 'remainingAmount'>) => `
Zyskaj nawet <b>${lastThresholdPercent}%</b> rabatu! <br>
Do osiągnięcia rabatu <b>${nextThresholdPercent}%</b> brakuje: <b>${showPriceWithCurrentCurrency(Number(remainingAmount), 2, 'comma')}</b>`;

export class Promotions {
	private static Selector = {
		BAR: ".js_promotions_bar",
		MIN_VALUE: ".js_promotions_minValue",
		MAX_VALUE: ".js_promotions_maxValue",
		REMAINING_AMOUNT_FOR_NEXT_THRESHOLD:
			".js_promotions_remainingAmountForNextThreshold",
		MESSAGE: ".js_promotions_message",
	};

	private static Values: ValueTypes = {
		currentThresholdMin: undefined as number | string,
		currentThresholdMax: undefined as number | string,
		remainingAmount: undefined as number | string,
		currentCartAmount: undefined as number | string,
		barWidth: undefined as number | string,
		currentThresholdPercent: undefined as number | string,
		nextThresholdPercent: undefined as number | string,
		lastThresholdPercent: undefined as number | string,
	};

	private static updateCurrentThresholdMinValue(newValue: number | string) {
		this.Values.currentThresholdMin = newValue;
		$(this.Selector.MIN_VALUE).text(
			showPriceWithCurrentCurrency(Number(newValue), 2, 'comma') || "-"
		);
	}

	private static updateCurrentThresholdMaxValue(newValue: number | string) {
		this.Values.currentThresholdMax = newValue;

		if (newValue !== null) {
			$(this.Selector.MAX_VALUE).text(
				showPriceWithCurrentCurrency(Number(newValue), 2, 'comma') || "-"
			);
		}
	}

	private static updateBarWidth(newValue: number | string) {
		this.Values.barWidth = newValue;
		$(this.Selector.BAR).width(`${newValue}%`);
	}

	private static updateRemainingAmount(newValue: number | string) {
		this.Values.remainingAmount = newValue;
		$(this.Selector.REMAINING_AMOUNT_FOR_NEXT_THRESHOLD).text(
			showPriceWithCurrentCurrency(Number(newValue), 2, 'comma') || "-"
		);
	}

	private static updateCurrentThresholdPercent(newValue: number | string) {
		this.Values.currentThresholdPercent = newValue;
	}

	private static updateNextThresholdPercent(newValue: number | string) {
		this.Values.nextThresholdPercent = newValue;
	}

	private static updateCurrentCartAmount(newValue: number | string) {
		this.Values.currentCartAmount = newValue;
	}

	private static getMessageAsHTML() {
		if (this.Values.currentThresholdMax === null || this.Values.currentThresholdMax === undefined) {
			return `Otrzymujesz dodatkowe <b>${this.Values.currentThresholdPercent}%</b> rabatu`;
		}

		return getRemainingAmountForNextThresholdTemplate({
			lastThresholdPercent: this.Values.lastThresholdPercent,
			remainingAmount: this.Values.remainingAmount,
			nextThresholdPercent: this.Values.nextThresholdPercent
		});
	}

	private static updateMessage(newMessage: string) {
		if (this.Values.currentThresholdMax === null || this.Values.currentThresholdMax === undefined) {
			$(this.Selector.MAX_VALUE).hide();
		} else {
			$(this.Selector.MAX_VALUE).show();
		}
		$(this.Selector.MESSAGE).html(newMessage);
	}

	private static calcBarWidth() {
		if (this.Values.currentThresholdMax === null || this.Values.currentThresholdMax === undefined) {
			return 100;
		}

		return (Number(this.Values.currentCartAmount) - Number(this.Values.currentThresholdMin)) / (Number(this.Values.currentThresholdMax) - Number(this.Values.currentThresholdMin)) * 100;
	}

	private static updateLastThresholdPercent(newValue: number | string) {
		this.Values.lastThresholdPercent = newValue;
	}

	static updateValues({
		barWidth,
		currentThresholdPercent: currentPromotionPercent,
		currentThresholdMin,
		currentThresholdMax,
		nextThresholdPercent: nextPromotionPercent,
		remainingAmount,
		currentCartAmount,
		lastThresholdPercent
	}: typeof this.Values) {
		this.updateLastThresholdPercent(lastThresholdPercent);
		this.updateCurrentThresholdMinValue(currentThresholdMin);
		this.updateCurrentThresholdMaxValue(currentThresholdMax);
		this.updateBarWidth(barWidth);
		this.updateRemainingAmount(remainingAmount);
		this.updateCurrentThresholdPercent(currentPromotionPercent);
		this.updateNextThresholdPercent(nextPromotionPercent);
		this.updateCurrentCartAmount(currentCartAmount);
		this.updateBarWidth(this.calcBarWidth());

		this.updateMessage(this.getMessageAsHTML());
	}
}
